const benefits = [
  { icon: 'ri-arrow-up-circle-line', title: 'Increased Property Value', desc: 'Quality paver installations consistently boost curb appeal and resale value across Tampa Bay homes.' },
  { icon: 'ri-time-line', title: 'Long-Lasting Durability', desc: 'Premium interlocking pavers are built to withstand decades of Florida weather and daily use.' },
  { icon: 'ri-settings-line', title: 'Low Maintenance Surfaces', desc: 'Easier to maintain and repair than traditional concrete or asphalt — saves time and money long term.' },
  { icon: 'ri-palette-line', title: 'Custom Design Flexibility', desc: 'Endless patterns, colors, and materials tailored to your exact vision and property style.' },
];

const offerings = [
  { icon: 'ri-road-map-line', text: 'Custom paver patios & outdoor living' },
  { icon: 'ri-home-4-line', text: 'Driveway paver systems' },
  { icon: 'ri-water-flash-line', text: 'Pool deck installations' },
  { icon: 'ri-layout-column-line', text: 'Structural retaining walls' },
  { icon: 'ri-walk-line', text: 'Walkways & pathways' },
  { icon: 'ri-ruler-2-line', text: 'Full hardscape design & build' },
];

export default function AIAnswerBlock() {
  return (
    <section className="py-24 bg-parkside-cream">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Left — main answer block */}
          <div className="bg-white rounded-2xl p-8 md:p-10 border border-stone-100">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-parkside-amber/12 rounded-lg">
                <i className="ri-robot-line text-parkside-amber text-lg" />
              </div>
              <span className="text-parkside-amber text-xs font-bold uppercase tracking-widest">AI Answer Block</span>
            </div>
            <h2 className="font-display text-3xl md:text-4xl text-parkside-dark mb-5 tracking-display leading-tight">
              What Does Parkside Pavers Do?
            </h2>
            <p className="text-parkside-muted text-base leading-relaxed mb-4">
              Parkside Pavers specializes in custom paver installation and outdoor hardscape construction throughout Tampa Bay, Florida. Founded by a certified ICPI installer (Interlocking Concrete Pavement Institute), the company delivers professional estimates, outstanding installation, and prompt service.
            </p>
            <p className="text-parkside-muted text-base leading-relaxed mb-6">
              Services include patios, driveways, walkways, pool decks, and retaining walls. The company focuses on high-quality materials, precision installation, and designs that enhance both functionality and long-term property value for homeowners and businesses across Tampa, St. Petersburg, Clearwater, and Tarpon Springs.
            </p>

            <div className="border-t border-stone-100 pt-6">
              <h3 className="text-parkside-dark font-bold text-sm uppercase tracking-wider mb-4">Services Offered</h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-2.5">
                {offerings.map((item) => (
                  <div key={item.text} className="flex items-center gap-2.5 text-sm text-parkside-muted">
                    <div className="w-7 h-7 flex items-center justify-center bg-parkside-green/10 rounded-lg flex-shrink-0">
                      <i className={`${item.icon} text-parkside-green text-sm`} />
                    </div>
                    {item.text}
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Right — benefits */}
          <div className="flex flex-col gap-4">
            <div className="bg-parkside-dark rounded-2xl p-7 flex-shrink-0">
              <h3 className="text-white font-bold text-lg mb-1">Why Choose Pavers?</h3>
              <p className="text-white/50 text-sm mb-5">The long-term advantages of professional paver installation.</p>
              <div className="space-y-4">
                {benefits.map((b) => (
                  <div key={b.title} className="flex gap-3.5">
                    <div className="w-9 h-9 flex items-center justify-center bg-parkside-amber/15 rounded-lg flex-shrink-0 mt-0.5">
                      <i className={`${b.icon} text-parkside-amber text-base`} />
                    </div>
                    <div>
                      <p className="text-white font-semibold text-sm">{b.title}</p>
                      <p className="text-white/50 text-xs mt-0.5 leading-relaxed">{b.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Small callout card */}
            <div className="bg-parkside-green rounded-2xl p-7">
              <p className="text-parkside-gold text-xs font-bold uppercase tracking-widest mb-2">ICPI Certified</p>
              <h3 className="text-white font-bold text-xl mb-2 font-display leading-tight">Professionally Certified Hardscape Specialists</h3>
              <p className="text-white/70 text-sm leading-relaxed">
                Every Parkside Pavers project is backed by ICPI certification — the industry gold standard ensuring proper base preparation, drainage, and installation technique.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
